<template>
  <div>

    <md-card>

      <!-- Title -->
      <md-card-header>
        <div class="md-title">{{ event.name }}
          <md-chip
            v-if="event.type === 'Class'"
            class="md-primary"
            key="evnetClass">クラス</md-chip>
          <md-chip
            v-else-if="event.type === 'Céilí'"
            class="md-accent"
            key="evnetCeili">ケーリー</md-chip>
          <md-chip
            v-else-if="event.type === 'SessionOrDance'"
            class="md-primary"
            key="evnetCeili">セッション/ダンス</md-chip>
        </div>
        <div class="md-subhead">Hosted by {{ event.host }}</div>
      </md-card-header>

      <md-card-content>
        {{ getEventDate(event.startTime, event.endTime) }}<br />
        @{{ getHoursAndMinutes(event.startTime) }}～{{ getHoursAndMinutes(event.endTime) }}<br />
        <p style="white-space: pre-wrap;" v-text="event.description">
          <!-- .replace(/\\n/g, '&lt;br/&gt;') -->
        </p>
      </md-card-content>

      <md-card-actions
        v-if="event.url"
        key="externalLink">
        <md-button
          :href="event.url"
          class="md-raised md-primary launchButton"
          target="_blank">詳細ページ <i class="material-icons">launch</i></md-button>
      </md-card-actions>

      <md-subheader>取り上げる予定のセット</md-subheader>
      <md-divider></md-divider>

      <md-list>
        <md-list-item
          v-for="(set, index) in selectedSets"
          :key="index"
          class="md-double-line">
          <md-avatar class="md-large">
            <router-link :to="{ name: 'Set', params: { setName: set }}">
              <img :src="allSets[set].figures[0].youtube ? getThumbnail(allSets[set].figures[0].youtube.url) : getThumbnail(allSets[set].thumbnail)" alt="Thumbnail" />
            </router-link>
          </md-avatar>
          <div class="md-list-text-container">
            <span>
              <!-- <router-link :to="{ name: 'EventSet', params: { eventId: eventId, setName: set }}"> -->
              <router-link v-if="allSets[set].needsSet" :to="{ name: 'Set', params: { setName: set }}">
                {{ set }} Set
              </router-link>
              <router-link v-else :to="{ name: 'Set', params: { setName: set }}">
                {{ set }}
              </router-link>
            </span>
            <span v-if="set.needsSet" class="jpCaption">
              {{ allSets[set].jpCaption }}・セット
            </span>
            <span v-else class="jpCaption">
              {{ allSets[set].jpCaption }}
            </span>
            <p>
              {{ getDescription(allSets[set]) }}
            </p>
          </div>
          <md-divider></md-divider>
        </md-list-item>

        <md-list-item v-if="event.lastSong === 'anthem'">
          <md-avatar
            class="md-large">
            <router-link :to="{ name: 'SoldiersSong' }">
              <img
                src="/static/img/ireland.gif"
                alt="Thumbnail" />
            </router-link>
          </md-avatar>
          <div class="md-list-text-container">
            <span>
              <router-link :to="{ name: 'SoldiersSong' }">
                Amhrán na bhFiann
              </router-link>
            </span>
            <span class="jpCaption">
              兵士の歌
            </span>
            <p>
              March - March - March
            </p>
          </div>
        </md-list-item>
        <md-list-item v-if="event.lastSong === 'shinano'">
          <md-avatar
            class="md-large">
            <!-- <router-link :to="{ name: 'Shinano' }">
              <img
                src="/static/img/websitebnr2013.jpg"
                alt="Thumbnail" />
            </router-link> -->
          </md-avatar>
          <div class="md-list-text-container">
            <span>
              <router-link :to="{ name: 'Shinano' }">
                信濃の国
              </router-link>
            </span>
            <span class="jpCaption">
              Shinano-no-kuni
            </span>
            <p>
              March - March - March - March - March - March
            </p>
          </div>
        </md-list-item>

      </md-list>

    </md-card>

    <br/>

    <div class="event-controller">
      <router-link
        tag="md-button"
        :to="{ name: 'EditEvent', params: { eventId: eventId } }"
        class="md-raised">イベントを編集する</router-link>
      <md-button
        class="md-raised md-primary"
        @click="openDialog('editSetsDialog')">セットを編集する</md-button>

        <p class="page-description">イベントはどなたでも編集することができます。イベントで扱われるセットをご存じでしたら登録していただけると幸いです。掲載内容にもし不都合がありましたら城までご連絡ください。</p>

    </div>

    <md-dialog
      md-open-from="#custom"
      md-close-to="#custom"
      ref="deleteEventDialog">
      <md-dialog-title>イベントを削除します</md-dialog-title>

      <md-dialog-content>
        この操作は取り消せません。{{ event.name }}を削除しますか？

      </md-dialog-content>

      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="cancelDialog('deleteEventDialog')">キャンセル</md-button>
        <md-button
          class="md-primary"
          @click="deleteEvent('deleteEventDialog')">削除する</md-button>
      </md-dialog-actions>

    </md-dialog>

    <md-dialog
      md-open-from="#custom"
      md-close-to="#custom"
      ref="editSetsDialog"
      :md-click-outside-to-close="false"
      :md-esc-to-close="false">
      <md-dialog-title>取り上げる予定のセット</md-dialog-title>

      <md-dialog-content>
        チェックの付いたセットがイベントページに表示されます。
        <md-list>
          <md-list-item
            v-for="(set, index) in allSets"
            :key="index"
            class="md-double-line">
            <md-checkbox
              :id="'checkbox' + index"
              name="my-test10"
              :md-value="set.name"
              v-model="selectedSets"
              class="md-primary"></md-checkbox>
            <div class="md-list-text-container">
              <span v-if="set.needsSet">
                {{ set.name }} Set
              </span>
              <span v-else>
                {{ set.name }}
              </span>
              <span v-if="set.needsSet" class="jpCaption">
                {{ set.jpCaption }}・セット
              </span>
              <span v-else class="jpCaption">
                {{ set.jpCaption }}
              </span>
            </div>
            <md-divider></md-divider>
          </md-list-item>
        </md-list>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="cancelEditSetsDialog('editSetsDialog')">キャンセル</md-button>
        <md-button
          class="md-primary"
          @click="addSets('editSetsDialog')">変更する</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>
</template>

<script>
import db from '../db'
import { getIdFromURL } from 'vue-youtube-embed'

// db.ref('/events').once('value').then(function (events) {
//   console.log(events.val())
// })
// db.ref('/events/').remove()

export default {
  name: 'event',
  data () {
    return {
      eventId: this.$route.params.eventId,
      event: {},
      eventRef: null,
      sets: {},
      tempSets: [],
      selectedSets: []
    }
  },
  firebase: {
    allSets: db.ref('/sets')
  },
  computed: {
  //   test: function () {
  //     if (this.isOnline === undefined) {
  //       console.log(this.isOnline)
  //       let connectedRef = db.ref('.info/connected')
  //       connectedRef.on('value', function (snap) {
  //         return snap.val() ? 'connected' : 'not connected'
  //       })
  //     } else {
  //       return this.isOnline ? 'connected' : 'not connected'
  //     }
  //   },
  //   isOnline: function () {
  //     let connectedRef = db.ref('.info/connected')
  //     connectedRef.on('value', function (snap) {
  //       if (snap.val() === true) {
  //         console.log('connected')
  //       } else {
  //         console.log('not connected')
  //       }
  //       return snap.val()
  //     })
  //   }
  },
  created () {
    let self = this
    db.ref('/events/' + this.eventId).once('value').then(function (event) {
      self.eventRef = event
      self.event = event.val()

      db.ref('/sets').once('value').then(function (sets) {
        for (let i in self.event.sets) {
          let setName = self.event.sets[i]
          self.$set(self.sets, setName, sets.val()[setName])
          self.selectedSets.push(setName)
        }
        self.$set(self, 'allSets', sets.val())

        // iPod Touch などの旧デバイスで配列が2重で表示されないようにする
        self.selectedSets = self.selectedSets.filter(function (x, i, self) { return self.indexOf(x) === i })
      })
    })
  },
  watch: {
    '$route': 'refreashData'
  },
  beforeRouteEnter: (to, from, next) => {
    db.ref('/events/' + to.params.eventId).once('value').then(function (event) {
      next((vm) => {
        vm.event = event.val()
      })
    })
  },
  methods: {
    refreashData () {
      this.eventId = this.$route.params.eventId
      this.selectedSets = []
      let self = this
      db.ref('/events/' + this.eventId).once('value').then(function (event) {
        self.event = event.val()

        for (let i in self.event.sets) {
          let setName = self.event.sets[i]
          self.$set(self.sets, setName, self.allSets[setName])
          self.selectedSets.push(setName)
        }
        // iPod Touch などの旧デバイスで配列が2重で表示されないようにする
        self.selectedSets = self.selectedSets.filter(function (x, i, self) { return self.indexOf(x) === i })
      })
    },
    getEventDate: function (startTime, endTime) {
      startTime = new Date(startTime)
      endTime = new Date(endTime)
      if ((startTime.getFullYear() === endTime.getFullYear()) && (startTime.getMonth() === endTime.getMonth()) && (startTime.getDate() === endTime.getDate())) {
        return startTime.getFullYear() + '年' + (startTime.getMonth() + 1) + '月' + startTime.getDate() + '日 (' + (['日', '月', '火', '水', '木', '金', '土'][new Date(startTime).getDay()]) + ') '
      } else {
        return startTime.getFullYear() + '年' + (startTime.getMonth() + 1) + '月' + startTime.getDate() + '日 (' + (['日', '月', '火', '水', '木', '金', '土'][new Date(startTime).getDay()]) + ')〜' + endTime.getDate() + '日 (' + (['日', '月', '火', '水', '木', '金', '土'][new Date(endTime).getDay()]) + ') '
      }
    },
    getHoursAndMinutes: function (dateTime) {
      let zeroFill = require('zero-fill')
      return new Date(dateTime).getHours() + ':' + zeroFill(2, new Date(dateTime).getMinutes())
    },
    getThumbnail: function (url) {
      // return 'http://i.ytimg.com/vi/' + getIdFromURL(url) + '/default.jpg'
      return 'https://i.ytimg.com/vi/' + getIdFromURL(url) + '/mqdefault.jpg'
    },
    getDescription: function (set) {
      let orders = []
      let rythmns = []
      let description = ''
      for (let i = 0; i < set.figures.length; i++) {
        // variation のあるフィガーのリズムを重複して表示しないようにする
        if (orders.indexOf(set.figures[i].order) < 0) {
          description += i !== 0 ? ' - ' + set.figures[i].rythmn : set.figures[i].rythmn
          orders.push(set.figures[i].order)
          rythmns.push(set.figures[i].rythmn)
        }
      }

      // すべてのフィガーが同じリズムのとき
      if (Array.from(new Set(rythmns)).length === 1) {
        return 'All ' + Array.from(new Set(rythmns))[0] + 's'
      }

      return description
    },
    openDialog (ref) {
      this.tempSets = [].concat(this.selectedSets)
      this.$refs[ref].open()
    },
    cancelDialog (ref) {
      this.$refs[ref].close()
    },
    addSets (ref) {
      this.selectedSets = this.selectedSets.filter(function (x, i, self) { return self.indexOf(x) === i })
      // this.selectedSets.sort()
      let eventRef = db.ref('/events/' + this.eventId + '/sets')
      eventRef.set(this.selectedSets)
      this.$refs[ref].close()
    },
    cancelEditSetsDialog (ref) {
      this.selectedSets = [].concat(this.tempSets)
      this.$refs[ref].close()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

.event-controller {
  padding-bottom: 32px;
}

.event-controller .md-button {
    margin: 12px 6px;
    /*padding: 4px 0;*/
}

.md-avatar.md-large {
  width: 113px;
  max-width: 113px;
  min-width: 113px;
}

.md-avatar {
  overflow: inherit;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 0 10px;
}

.md-dialog li {
  margin: 0;
}

a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// Event.vue?ea3be1ba